module.exports = __webpack_public_path__ + "img/towd_1.7292e703.jpg";